export const META_TYPE = 'simResult';
export const META_VER = 'v1';

export const CMD_SIMRESULT_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
